<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<app-progress></app-progress>
<div class="p-8 table-list mat-typography">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <span>{{dataSource && dataSource.data ? (dataSource.data.length | i18nPlural: locationPluralMapping) : '0 Locations'}}</span>
        <span class="float-right">
          @if (admin) {
            <a [routerLink]="['add']" aria-label="Add Facility" color="primary"
            mat-raised-button="">Create New Location</a>
          }
        </span>
      </mat-card-title>
      <mat-card-subtitle>
        <mat-form-field>
          <input (keyup)="search($event)" matInput placeholder="Search">
        </mat-form-field>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mat-elevation-z8">
      <table [dataSource]="dataSource" mat-table matSort [matSortDisableClear]="true">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
          <td *matCellDef="let element" mat-cell><a
          [routerLink]="[element.id, 'items']">{{element.name}}</a></td>
        </ng-container>

        <!-- Created Column -->
        <ng-container matColumnDef="created">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
          <td *matCellDef="let row" mat-cell>{{row.created.toDate() | dateFormat}}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef class="column-less" mat-header-cell>@if (admin) {
            <span>Actions</span>
          }</th>
          <td *matCellDef="let row" mat-cell>
              <div class="flex items-center gap-2">
            @if (admin) {
              <button [routerLink]="['edit', row.id]" class="mat-elevation-z0" color="primary"
                mat-mini-fab><i class="material-icons">edit</i>
              </button>
            }
            @if (admin) {
              <button (click)="deleteLocation($event, row)" class="mat-elevation-z0" color="primary" mat-mini-fab><i
              class="material-icons">delete</i></button>
            }
              </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </table>
        <mat-paginator [pageSizeOptions]="[15, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
